module.exports = __webpack_public_path__ + "bacbc36b71c1d1b1fa1bc735c6b6357a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/promo/ts_social.jpg
// module id = 1043
// module chunks = 0